import { CardFooter as BaseCardFooter } from "../vendor/Card/CardFooter.js";

export type CardFooterProps = {
  /**
   * A React component or the name of an HTML tag used to render the element.
   *
   * @default footer
   */
  as?: React.ElementType | undefined;

  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A Card footer displays at the bottom of a Card element.
 *
 * ![Card footer](./screenshots/card_footer.png)
 *
 * @param props
 * @see {@link Card}
 * @see {@link CardTitle}
 */
export const CardFooter = (props: CardFooterProps) => (
  <BaseCardFooter {...props} />
);
